export default __webpack_public_path__ + "6b49031e43cdb023370e58c25ce42804.webp";